export const ASSET_PUBLIC_SHARED_GET_DATA = 'ASSET_PUBLIC_SHARED_GET_DATA'
export const ASSET_PUBLIC_SHARED_GET_DATA_SUCCESS = 'ASSET_PUBLIC_SHARED_GET_DATA_SUCCESS'
export const ASSET_PUBLIC_SHARED_GET_DATA_FAILURE = 'ASSET_PUBLIC_SHARED_GET_DATA_FAILURE'
export const ASSET_PUBLIC_NAVIGATE_SHARED_DATA_SUCCESS = 'ASSET_PUBLIC_NAVIGATE_SHARED_DATA_SUCCESS'
export const ASSET_PUBLIC_NAVIGATE_SHARED_RETURN_FOLDER = 'ASSET_PUBLIC_NAVIGATE_SHARED_RETURN_FOLDER'
export const ASSET_PUBLIC_SHARED_EXPAND_UNSET_SELECT = 'ASSET_PUBLIC_SHARED_EXPAND_UNSET_SELECT'
export const ASSET_PUBLIC_SHARED_EXPAND_SELECT = 'ASSET_PUBLIC_SHARED_EXPAND_SELECT'
export const PUBLIC_SHARED_SET_SELECT = 'PUBLIC_SHARED_SET_SELECT'
export const PUBLIC_SHARED_UNSET_SELECT = 'PUBLIC_SHARED_UNSET_SELECT'
export const PUBLIC_SHARED_ACTIVEVIEW = 'PUBLIC_SHARED_ACTIVEVIEW'
export const ASSET_HAS_PASSWORD = "ASSET_HAS_PASSWORD"
export const ASSET_HAS_PASSWORD_SUCCESS = "ASSET_HAS_PASSWORD_SUCCESS"
export const ASSET_HAS_PASSWORD_FAILURE = "ASSET_HAS_PASSWORD_FAILURE"

export const ASSETS_PUBLIC_MULTI_DELETE = 'ASSETS_PUBLIC_MULTI_DELETE'
export const ASSETS_PUBLIC_MULTI_DELETE_SUCCESS = 'ASSETS_PUBLIC_MULTI_DELETE_SUCCESS'
export const ASSETS_PUBLIC_MULTI_DELETE_FAILURE = 'ASSETS_PUBLIC_MULTI_DELETE_FAILURE'

export const ASSETS_PUBLIC_MULTI_MOVE = 'ASSETS_PUBLIC_MULTI_MOVE'
export const ASSETS_PUBLIC_MULTI_MOVE_SUCCESS = 'ASSETS_PUBLIC_MULTI_MOVE_SUCCESS'
export const ASSETS_PUBLIC_MULTI_MOVE_FAILURE = 'ASSETS_PUBLIC_MULTI_MOVE_FAILURE'
